import {
  AUTH_IS_FETCHING,
  AUTH_SUCCESS,
  AUTH_FAILED
} from '../types'

const initialState = {
  isFetching: true,
  isAuthenticated: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case AUTH_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload
      }

    case AUTH_SUCCESS:
      return {
        ...state,
        isAuthenticated: true
      }

    case AUTH_FAILED:
      return {
        ...state,
        isAuthenticated: false
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js